'use strict';

import { decodeHtml, getVueTemplate } from '../../../_imports/utils/utils.common';
import BaseVueComponent from '../../../_imports/shared/base-vue-component.vue.common';
import CallToAction from '../../../cta/cta.vue';

export default {
    template: getVueTemplate('series-video-next-message'),
    mixins: [
        BaseVueComponent,
    ],
    components: {
        CallToAction
    },
    props: {
        currentResource: Object,
        series: Object,
    },
    data() {
        return {
            isVisible: false,
            videoPlayer: null
        }
    },
    computed: {
        title() {
            return decodeHtml(this?.data?.title);
        },
        text() {
            return decodeHtml(this?.data?.text);
        },
        video() {
            return this.resourceVideo?.video;
        },
        excerpt() {
            return decodeHtml(this.resourceVideo?.resource?.shortDescription ?? this.video?.description);
        },
        callToActions() {
            return this?.data?.callToActions;
        },
        resourceVideo() {
            if (!this.series?.resourceVideos) {
                return null;
            }

            const currentIndex = this.series.resourceVideos.findIndex((resourceVideo) => resourceVideo.video.videoCode === this.currentResource?.video?.video?.videoCode);

            if (currentIndex === -1
                || currentIndex === this.series.resourceVideos.length) {
                return null;
            }

            return this.series.resourceVideos[currentIndex + 1];
        },
        videoDurationInMinutes() {
            return this.videoHasDuration ? Math.ceil(this.video.duration / 60) : 0;
        },
        hasNextResourceVideo() {
            return !!this.resourceVideo;
        },
        hasCallToActions() {
            return this.callToActions?.length;
        },
        videoHasDuration() {
            return !!this.video?.duration;
        },
    },
    watch: {
        isVisible() {
            const timer = 15000;
            let timerProgress = 0;

            const interval = setInterval(() => {
                timerProgress += timer / 1000;

                this.$el.style.setProperty('--next-message-progress', `${(timerProgress / timer * 100).toFixed(2)}%`);

                if (timerProgress >= timer) {
                    clearInterval(interval);

                    this.goToNextResource();
                }
            }, timer / 1000);
        },
        videoPlayer() {
            if (this.videoPlayer) {
                this.videoPlayer.innerPlayer.bind('end', () => {
                    this.isVisible = true;
                    this.videoPlayer.pause();
                });
            }
        },
    },
    created() {
        if (this.currentResource?.video?.video) {
            CoveoWebsite.videoApi.onReady(this.currentResource.video.video.videoCode, (player) => {
                this.videoPlayer = player;
            });
        }
    },
    methods: {
        goToNextResource() {
            if (this.resourceVideo.landingUrl) {
                window.location.href = this.resourceVideo.landingUrl;
            }
        },
    }
};